/**
 * Theme Registry
 *
 * Central export point for the theme system.
 */
export type {
  ThemeMode,
  AppTheme,
  RedesignThemeColors,
  SemanticThemeColors,
  ComponentThemeColors,
  AdminComponentTheme,
  Typography,
  Spacing,
  Radius,
  Shadow,
  Motion,
  TypographyToken,
  FontWeight,
  ShadowShape,
} from './types';
export { darkTheme } from './darkTheme';
export { lightTheme } from './lightTheme';
export {
  getGlows,
  getGradientColors,
  getCssRadialGlows,
  getCssEdgeFades,
  CANVAS_EDGE_FADE_PX,
} from './gradients';
export { TYPOGRAPHY, PAYMENT_TYPOGRAPHY, MOBILE_TYPOGRAPHY } from './typography';
export { SPACING } from './spacing';
export { RADIUS } from './radius';
export { SHADOW_SHAPES } from './shadow';
export { MOTION } from './motion';
export {
  onColor,
  contrastRatio,
  relativeLuminance,
  ON_LIGHT_INK,
  ON_DARK_INK,
} from './onColor';

import { darkTheme } from './darkTheme';
import { lightTheme } from './lightTheme';
import type { ThemeMode, AppTheme } from './types';

const themes: Record<ThemeMode, AppTheme> = {
  dark: darkTheme,
  light: lightTheme,
};

export function getTheme(mode: ThemeMode): AppTheme {
  return themes[mode];
}
